import $ from "jquery";
import React, { useState, useEffect, forwardRef, useContext } from 'react';
import Toastr from 'toastr';
import DropdownButton from '../../components/bootstrap4/DropdownButton';
import SessionManager from '../../routes/SessionManager';
import Loading from '../Loading';
import ReactGA from 'react-ga4';
import Input from '../bootstrap4/Input'
import { Context } from "../../views/app";

function ModifyZone(props, refs) {
    let sessionManager = new SessionManager();;
    let user = sessionManager.readCookie('user');
    let appContext = useContext(Context);
    let siteComponentRef = props.site_component;

    const [zone_selected, setZoneSelected] = useState(null);
    const [zones, setZones] = useState(user.zones);
    const [location_name_new, setLocationNameNew] = useState('');
    const [loading, setLoading] = useState(false);

    const onZoneSelected = (zoneSelected) => {
        setZoneSelected(zoneSelected);
        setLocationNameNew(zoneSelected.location_name);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        setLocationNameNew(value);
    }

    const resetChanges = (zone = zones) => {
        setLoading(false);
        setZoneSelected(null);
        setLocationNameNew('');
        setZones(zone);
    }

    useEffect(() => {
        const element = document.getElementsByName("location_name_new")[0]
        element.setAttribute("style", { borderColor: "#efefef" })
        isChanged();
    }, [zones]);

    const isChanged = () => {
        let isModified = false;
        if (zone_selected !== null) {
            isModified = location_name_new !== '' && location_name_new !== zone_selected.location_name;
        }
        siteComponentRef('modify_zone', isModified);
        return isModified;
    }

    const modifyZone = () => {

        const element = document.getElementsByName("location_name_new")[0]
        const lIsValidText = $(element).attr("isvalidtext")
        if (!(lIsValidText === "true" || lIsValidText === true)) {
            const lErrorText = $(element).attr("invaliderrormsg")

            const position = Toastr.options.positionClass
            Toastr.options.positionClass = 'toast-top-center';
            Toastr.error(lErrorText);
            Toastr.options.positionClass = position;
            return;
        }

        if (user.zones.find(z => z.location_name.trim() === location_name_new.trim())) {
            Toastr.error(`"${location_name_new}" is already exists`);
            return
        }

        setLoading(true);

        var data = {
            form_input: { site_id: user.site_selected.site_id, location_id: zone_selected.location_id, location_name: location_name_new },
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        var basicInputs = { site_id: null, location_id: null, location_name: null };
        for (var k in basicInputs) {
            if (data.form_input[k] == null || data.form_input[k] === '') {
                Toastr.error('All fields are mandatory !');
                return;
            } else {
                basicInputs[k] = data.form_input[k];
            }
        }
        data.form_input = basicInputs;

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location/modify',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success('Zone info modified successfully !');

                    var zone = [...zones];
                    for (var zone_s of zone) {
                        if (zone_s.location_id === basicInputs.location_id) {
                            zone_s.location_name = basicInputs.location_name;
                            // Store Zone into our cookie as well to reflect instantly.
                            let zonesUser = [...user.zones];
                            for (let i = 0; i < zonesUser.length; i++) {
                                if (zonesUser[i].location_id === zone_s.location_id) {
                                    zonesUser[i].location_name = zone_s.location_name;
                                }
                            }
                            let _user = { ...user };
                            _user.zones = zonesUser;
                            appContext.updateUser(_user);
                        }
                    }
                    resetChanges(zone);
                }
            },
            (res) => {

            });

        ReactGA.event({
            category: 'Action',
            action: 'Clicked ModifyZone Save Button',
            label: 'Modified Zone from ' + zone_selected.location_name + ' to ' + location_name_new,
        });
    }

    React.useImperativeHandle(refs, () => (
        {
            resetChanges,
            modifyZone
        }));

    const selectedZone = zone_selected ? zone_selected.location_id : null;

    return (
        <React.Fragment>
            {loading &&
                <div>
                    <Loading> Saving Zone Information ...</Loading>
                </div>}
            {!loading && <React.Fragment>
                <div className="row">
                    <div className="col-md-3 col-5">
                        <label className="mr-2">Select Zone :</label>
                    </div>
                    <div className="col-7">
                        <DropdownButton
                            className="btn btn-sm dropdown-toggle text-dark"
                            onOptionClick={onZoneSelected}
                            default={zones.length === 0 ? "No zones found" : "Choose Zone"}
                            selected={selectedZone}
                            opts={zones}
                            field_attr='location_id'
                            value_attr='location_name' />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-3 col-5">
                        <label>Edit Name :</label>
                    </div>
                    <div className="col-7">
                        <Input name="location_name_new" type="text" className="form-control d-inline width-100-perc" placeholder="New Zone Name" disabled={zone_selected === null} onChange={handleInputChange} value={location_name_new} autoComplete="off" />
                    </div>
                </div>
                <div className="row pt-2 hide">
                    <div className="col-md-12 text-center">
                        <button ref={refs} type="button" className="btn btn-primary btn-sm m-3 px-3" onClick={(e) => modifyZone(e)} disabled={!isChanged()}>Save</button>
                    </div>
                </div>

                <br />
                <br />
            </React.Fragment>
            }
        </React.Fragment>
    );
}

export default forwardRef(ModifyZone);